import Vue from 'vue';
import Router from 'vue-router';
import VueWechatTitle from 'vue-wechat-title' //可以动态修改浏览器标题的插件
Vue.use(VueWechatTitle);
Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default new Router({
    routes: [ 
        {
            path: '/',
            redirect: '/comOrder'
        },   
        {
            path: '/',
            component:resolve => require([/* webpackChunkName: "home" */ '../components/common/Home.vue'],resolve),
            meta: { title: '后台页面' },
            children: [
                {
                    path: '/dashboard',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'],resolve),
                    meta: { title: '数据中心' }
                },
                {
                    path: '/dashboard1',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/Dashboard1.vue'],resolve),
                    meta: { title: '系统首页1' }
                },
                {
                    path: '/dataBody1',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataBody1.vue'],resolve),
                    meta: { title: '数据中心',permission: true }
                },
                {
                    path: '/dataTs1',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataTs1.vue'],resolve),
                    meta: { title: '投诉分析',permission: true }
                },{
                    path: '/dataAnalysisNav',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataAnalysisNav.vue'],resolve),
                    meta: { title: '数据分析',permission: true }
                },{
                    path: '/dataReportNav',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataReportNav.vue'],resolve),
                    meta: { title: '数据报表',permission: true }
                },{
                    path: '/dataNav',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataNav.vue'],resolve),
                    meta: { title: '数据大盘',permission: true }
                },

                {
                    path: '/dataBody1BAK',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataBody1BAK.vue'],resolve),
                    meta: { title: '数据总览-旧版' }
                },
                {
                    path: '/dataBody3',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataBody3.vue'],resolve),
                    meta: { title: '数据统计' }
                },
                {
                    path: '/icon',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/Icon.vue'],resolve),
                    meta: { title: '图标列表' }
                },
                {
                    path: '/dataBody4',
                    component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataBody4.vue'],resolve),
                    meta: { title: '转化分析' }
                }, {
                    path: '/members',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/Members.vue'],resolve),
                    meta: { title: '所有会员' }
                }, {
                    path: '/memberAll',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/channel/MemberAll.vue'],resolve),
                    meta: { title: '渠道列表', permission: true  }
                },{
                    path: '/comAppName',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComAppName.vue'],resolve),
                    meta: { title: 'APP包名', permission: true  }
                },{
                    path: '/comStateTd',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/userData/ComStateTd.vue'],resolve),
                    meta: { title: '退订数据', permission: true  }
                },{
                    path: '/tsType',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/appeal/TsType.vue'],resolve),
                    meta: { title: '投诉分类'  }
                },{
                    path: '/comStateTs',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/userData/ComStateTs.vue'],resolve),
                    meta: { title: '投诉数据', permission: true  }
                },{
                    path: '/woNav',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/appeal/WONav.vue'],resolve),
                    meta: { title: '投诉工单'   }
                },{
                    path: '/woManageNav',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/appeal/WOManageNav.vue'],resolve),
                    meta: { title: '投诉处理', permission: true  }
                },{
                    path: '/comStateHmd',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/userData/ComStateHmd.vue'],resolve),
                    meta: { title: '黑名单数据', permission: true  }
                },{
                    path: '/userDataPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/userData/UserDataPage.vue'],resolve),
                    meta: { title: '异常汇总', permission: true  }
                },{
                    path: '/dataHisPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/system/DataHisPage.vue'],resolve),
                    meta: { title: '数据历史', permission: true  }
                },{
                    path: '/cashGoodsPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/CashGoodsPage.vue'],resolve),
                    meta: { title: '下游结算', permission: true  }
                },
                {
                    path: '/channelWait',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/cash/ChannelWait.vue'],resolve),
                    meta: { title: '上游结算', permission: true  }
                },{
                    path: '/ersAccount',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/cash/ErsAccount.vue'],resolve),
                    meta: { title: '对公账户', permission: true  }
                },

                {
                    path: '/statWait',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/cash/StatWait.vue'],resolve),
                    meta: { title: '财务统计', permission: true  }
                },

                {
                    path: '/memberWait',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/cash/MemberWait.vue'],resolve),
                    meta: { title: '下游结算', permission: true  }
                },
                {
                    path: '/channelType',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/channel/ChannelType.vue'],resolve),
                    meta: { title: '资源分类', permission: true  }
                },{
                    path: '/qychannel',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/channel/QyChannel.vue'],resolve),
                    meta: { title: '权益渠道', permission: true  }
                },{
                    path: '/channel',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/channel/Channel.vue'],resolve),
                    meta: { title: '上游渠道', permission: true  }
                },{
                    path: '/goodsTag',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/GoodsTag.vue'],resolve),
                    meta: { title: '产品标签', permission: true  }
                },
                {
                    path: '/logLogin',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/LogLogin.vue'],resolve),
                    meta: { title: '登录日志', permission: true  }
                },
                {
                    path: '/docShareType',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/doc/DocShareType.vue'],resolve),
                    meta: { title: '文档分类', permission: true  }
                },
                {
                    path: '/docShare',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/doc/DocShare.vue'],resolve),
                    meta: { title: '共享文档', permission: true  }
                },{
                    path: '/docPerson',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/doc/DocPerson.vue'],resolve),
                    meta: { title: '个人文档', permission: true  }
                },
                {
                    path: '/logOper',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/LogOper.vue'],resolve),
                    meta: { title: '操作日志', permission: true  }
                },
                {
                    path: '/logError',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/LogError.vue'],resolve),
                    meta: { title: '异常日志', permission: true  }
                },
                {
                    path: '/docDown',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/doc/DocDown.vue'],resolve),
                    meta: { title: '下载记录', permission: true  }
                },
                {
                    path: '/city',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/City.vue'],resolve),
                    meta: { title: '地区维护', permission: true  }
                },
                {
                    path: '/channelNav',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/channel/ChannelNav.vue'],resolve),
                    meta: { title: '系统导航', permission: true  }
                },
                {
                    path: '/comApilimit',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComApilimit.vue'],resolve),
                    meta: { title: '接口风控', permission: true  }
                }, {
                    path: '/comApiwarn',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComApiwarn.vue'],resolve),
                    meta: { title: '接口预警', permission: true  }
                }, {
                    path: '/comGoods',
                    name:'comGoods',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/goods/ComGoods.vue'],resolve),
                    meta: { title: '产品列表',keepAlive: true,  permission: true  }
                },  {
                    path: '/comGoods2',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/goods/ComGoods2.vue'],resolve),
                    meta: { title: '产品管理'   }
                }, {
                    path: '/comGoodsGroup',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComGoodsGroup.vue'],resolve),
                    meta: { title: '产品组合', permission: true  }
                }, {
                    path: '/configPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/system/ConfigPage.vue'],resolve),
                    meta: { title: '系统配置', permission: true  }
                },  {
                    path: '/docPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/doc/DocPage.vue'],resolve),
                    meta: { title: '文档管理', permission: true  }
                }, {
                    path: '/rolePage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/role/RolePage.vue'],resolve),
                    meta: { title: '权限管理', permission: true  }
                }, {
                    path: '/taskPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/system/TaskPage.vue'],resolve),
                    meta: { title: '轮询配置', permission: true  }
                },
                {
                    path: '/navPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/system/NavPage.vue'],resolve),
                    meta: { title: '系统导航', permission: true  }
                }, {
                    path: '/navLink',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/system/sysNav/NavLink.vue'],resolve),
                    meta: { title: '', permission: true  }
                },{
                    path: '/logsPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/system/LogsPage.vue'],resolve),
                    meta: { title: '日志记录', permission: true  }
                },{
                    path: '/comGoodsDoc',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComGoodsDoc.vue'],resolve),
                    meta: { title: '产品资料', permission: true  }
                }, {
                    path: '/wxWork',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WxWork.vue'],resolve),
                    meta: { title: '企微应用', permission: true  }
                },{
                    path: '/wxWorkConfig',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WxWorkConfig.vue'],resolve),
                    meta: { title: '企微配置', permission: true  }
                },{
                    path: '/wxWorkUser',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WxWorkUser.vue'],resolve),
                    meta: { title: '企微成员', permission: true  }
                },{
                    path: '/wxWorkGroup',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WxWorkGroup.vue'],resolve),
                    meta: { title: '企微群聊', permission: true  }
                },{
                    path: '/wxWorkMsg',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WxWorkMsg.vue'],resolve),
                    meta: { title: '消息推送', permission: true  }
                },{
                    path: '/h5TemplateConfig',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/H5TemplateConfig.vue'],resolve),
                    meta: { title: '模板配置', permission: true  }
                },{
                    path: '/h5template',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/H5template.vue'],resolve),
                    meta: { title: '落地页模板', permission: true  }
                },{
                    path: '/comSms',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComSms.vue'],resolve),
                    meta: { title: '短信配置', permission: true  }
                },{
                     path: '/comOrder',
                     name: 'comOrder',
                     component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/order/ComOrder.vue'],resolve),
                     meta: { title: '订单列表',keepAlive: true,   permission: true  }
                 },{
                      path: '/comOrder2',
                      component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/order/ComOrder2.vue'],resolve),
                      meta: { title: '订单管理' }
                  },{
                      path: '/comOrderQyPush',
                      component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/order/ComOrderQyPush.vue'],resolve),
                      meta: { title: '权益推送' }
                  },{
                    path: '/comOrderWaitTM',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComOrderWaitTM.vue'],resolve),
                    meta: { title: '天猫卡单处理', permission: true  }
                }, {
                    path: '/goodsType',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/GoodsType.vue'],resolve),
                    meta: { title: '产品分类', permission: true  }
                },{
                    path: '/goodsFrom',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/GoodsFrom.vue'],resolve),
                    meta: { title: '产品来源', permission: true  }
                },
                {
                    path: '/goodsRead',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/GoodsRead.vue'],resolve),
                    meta: { title: '订购条款' }
                },{
                    path: '/comMyOrder',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComMyOrder.vue'],resolve),
                    meta: { title: '我的订单' }
                },{
                    path: '/comPhoneArea',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComPhoneArea.vue'],resolve),
                    meta: { title: '号码归属地' }
                },{
                    path: '/woManageNav',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WOManageNav.vue'],resolve),
                    meta: { title: '工单处理' }
                },{
                    path: '/woNav',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WONav.vue'],resolve),
                    meta: { title: '我的工单' }
                },{
                    path: '/woHandle',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WOHandle.vue'],resolve),
                    meta: { title: '处理中' }
                }, {
                    path: '/activeCode',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ActiveCode.vue'],resolve),
                    meta: { title: '活码工具' }
                },  {
                    path: '/operItem',
                    component:resolve => require([/* webpackChunkName: "tabs" */ '../view/role/OperItem.vue'],resolve),
                    meta: { title: '菜单管理', permission: true  }
                },{
                    path: '/operRole',
                    component:resolve => require([/* webpackChunkName: "tabs" */ '../view/role/OperRole.vue'],resolve),
                    meta: { title: '角色管理', permission: true  }
                },{
                    path: '/operUserRole',
                    component:resolve => require([/* webpackChunkName: "tabs" */ '../view/role/OperUserRole.vue'],resolve),
                    meta: { title: '渠道角色', permission: true  }
                }, {
                    path: '/comUserPer',
                    component:resolve => require([/* webpackChunkName: "tabs" */ '../view/user/ComUserPer.vue'],resolve),
                    meta: { title: '员工岗位', permission: true  }
                }, {
                    path: '/comUser',
                    component:resolve => require([/* webpackChunkName: "tabs" */ '../view/user/ComUser.vue'],resolve),
                    meta: { title: '员工列表', permission: true  }
                }, {
                    path: '/operChannel',
                    component:resolve => require([/* webpackChunkName: "tabs" */ '../components/page/OperChannel.vue'],resolve),
                    meta: { title: '用户管理' , permission: true }
                }, {
                    path: '/memberSet',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/MemberSet.vue'],resolve),
                    meta: { title: '个人信息' }
                },  
                {
                    path: '/webSiteConfig',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/WebSiteConfig.vue'],resolve),
                    meta: { title: '系统配置', permission: true  }
                },
                {
                    path: '/paySet',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/PaySet.vue'],resolve),
                    meta: { title: '商户配置', permission: true  }
                }, 
                {
                    path: '/gzh',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/GzhSet.vue'],resolve),
                    meta: { title: '公众号配置', permission: true  }
                },
                {
                    path: '/comEmail',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../components/page/ComEmail.vue'],resolve),
                    meta: { title: '邮箱配置' , permission: true }
                }, 
                {
                    path: '/loginPage',
                    component:resolve => require([/* webpackChunkName: "appletBinding" */ '../view/system/LoginPage.vue'],resolve),
                    meta: { title: '登录配置' }
                },
                {
                    // 权限页面
                    path: '/permission',
                    component:resolve => require([/* webpackChunkName: "permission" */ '../components/page/Permission.vue'],resolve),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    path: '/404',
                    component:resolve => require([/* webpackChunkName: "404" */ '../components/page/404.vue'],resolve),
                    meta: { title: '404' }
                },{
                    path: '/welcome',
                    component:resolve => require([/* webpackChunkName: "404" */ '../view/system/login/welcome.vue'],resolve),
                    meta: { title: 'welcome' }
                },
                {
                    path: '/no',
                    component:resolve => require([/* webpackChunkName: "404" */ '../components/page/no.vue'],resolve),
                    meta: { title: '未开放' }
                },
                {
                    path: '/403',
                    component:resolve => require([/* webpackChunkName: "403" */ '../components/page/403.vue'],resolve),
                    meta: { title: '403' }
                }, 
            ]
        },
        {
            path: '/login',
            component:resolve => require([/* webpackChunkName: "login" */ '../view/system/login/Login.vue'],resolve),
            meta: { title: '登录' ,noLock: true } // 标记此页面不触发锁屏逻辑[4,7](@ref)
        },
        {
            path: '/dataNav',
            component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/DataNav.vue'],resolve),
            meta: { title: '数据大盘',permission: true }
        },
        {
            path: '/dataShow',
            component:resolve => require([/* webpackChunkName: "dashboard" */ '../components/page/dataShow/index.vue'],resolve),
            meta: { title: '数据面板' }
        },
        {
            path: '/forPass',
            component:resolve => require([/* webpackChunkName: "login" */ '../components/page/ForgetPass.vue'],resolve),
            meta: { title: '忘记密码' }
        }, 
     
        {
            path: '/forPhone',
            component:resolve => require([/* webpackChunkName: "login" */ '../components/page/ForgetPhone.vue'],resolve),
            meta: { title: '换绑手机号' }
        }, 
        {
            path: '/forByInfo',
            component:resolve => require([/* webpackChunkName: "login" */ '../components/page/ForgetByInfo.vue'],resolve),
            meta: { title: '更换手机号' }
        },
        {
            path: '/tsHandleHis/:id',
            component:resolve => require([/* webpackChunkName: "login" */ '../view/appeal/TsHandleHis.vue'],resolve),
            meta: { title: '更换手机号' }
        },
    ]
});
